import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumbEmailMarketingSpecialist from '../components/BreadcrumbEmailMarketingSpecialist'
import EmailMarketingcomponent from '../components/EmailMarketingcomponent'


export default function EmailMarketingSpecialist() {
  return (
    <div>
      <Header1/>
      <BreadcrumbEmailMarketingSpecialist/>
      <EmailMarketingcomponent/>
      <Footer/>
    </div>
  )
}
